import { Breakpoint } from '@/enums'
import { themeBreakpointDown } from '@/utils'
import styled from 'styled-components'
import { ifProp } from 'styled-tools'
import { Row } from '../../styled'

export const Container = styled(Row)`
  gap: 4px;
  align-items: center;
  flex-direction: ${ifProp('reverse', 'row-reverse', 'row')};

  ${themeBreakpointDown(Breakpoint.xs)} {
    gap: 4px;
  }

  span {
    margin-top: 2px;
  }

  use {
    fill: ${(props) => props.theme.color.warning3};
  }
`
